import {gql} from '@apollo/client';

const UPDATE_COUNTRY_DRIVER_CONCEPT_TYPE = gql`
  mutation updateCountryDriverConceptType(
    $id: ID!
    $name: String!
    $description: String
    $multiplicationFactor: Float! = 1
    $dailyAllowance: Float!
  ) {
    updateCountryDriverConceptType(
      input: {
        id: $id
        name: $name
        description: $description
        multiplicationFactor: $multiplicationFactor
        dailyAllowance: $dailyAllowance
      }
    ) {
      id
      name
      description
      multiplicationFactor
      dailyAllowance
    }
  }
`;

export default UPDATE_COUNTRY_DRIVER_CONCEPT_TYPE;
